/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Strainer } from "./modelStrainer";

class ControllerStrainer extends ControllerModel {
    constructor() {
        super("ControllerStrainer");

        this.setNewNode = (callback) => {
            let strainer = new Strainer();
            strainer.decorate(callback);

            this.addNode(strainer);
            SingletonFlowchart.SaveStatus();
        };

        this.loadNode = (node, callback) => {
            let strainer = new Strainer();
            strainer.copyFrom(node);
            strainer.decorate(callback);
            this.addNode(strainer);
        };

        this.getProperties = async (node) => {
            let n = new Strainer();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Strainer();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerStrainer };